import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

type RecentCallsRealtimeStore = {
  activeConsumerCount: number;
  isActive: boolean;
  registerConsumer: () => void;
  unregisterConsumer: () => void;
};

export const useRecentCallsRealtimeStore = createStoreWithSubscribe<RecentCallsRealtimeStore>(
  (set) => ({
    activeConsumerCount: 0,
    isActive: false,
    registerConsumer: () => {
      set((state) => {
        state.activeConsumerCount += 1;
        state.isActive = state.activeConsumerCount > 0;
      });
    },
    unregisterConsumer: () => {
      set((state) => {
        state.activeConsumerCount = Math.max(0, state.activeConsumerCount - 1);
        state.isActive = state.activeConsumerCount > 0;
      });
    },
  }),
  {
    name: 'RecentCallsRealtimeStore',
    trace: true,
  }
);

export const useRecentCallsRealtimeShallowStore =
  createShallowStore<RecentCallsRealtimeStore>(useRecentCallsRealtimeStore);
